var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAncillaryReserve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5H17V9.36C18.72 8.91 20 7.36 20 5.5H17V4.5C17 3.95 16.55 3.5 16 3.5H8C7.45 3.5 7 3.95 7 4.5V5.5H4C4 7.36 5.28 8.91 7 9.36V10.5H4C4 12.36 5.28 13.91 7 14.36V15.5H4C4 17.36 5.28 18.91 7 19.36V20.5C7 21.05 7.45 21.5 8 21.5H16C16.55 21.5 17 21.05 17 20.5V19.36C18.72 18.91 20 17.36 20 15.5H17V14.36C18.72 13.91 20 12.36 20 10.5ZM12 19.5C10.89 19.5 10 18.6 10 17.5C10 16.4 10.89 15.5 12 15.5C13.1 15.5 14 16.4 14 17.5C14 18.6 13.11 19.5 12 19.5ZM12 14.5C10.89 14.5 10 13.6 10 12.5C10 11.4 10.89 10.5 12 10.5C13.1 10.5 14 11.4 14 12.5C14 13.6 13.11 14.5 12 14.5ZM12 9.5C10.89 9.5 10 8.6 10 7.5C10 6.39 10.89 5.5 12 5.5C13.1 5.5 14 6.39 14 7.5C14 8.6 13.11 9.5 12 9.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAncillaryReserve);
export default __webpack_public_path__ + "static/media/ancillary-reserve.ecd7063aee895372edaf07a307fd9ab4.svg";
export { ForwardRef as ReactComponent };